import request from '@/utils/request'
//单位信息变更

//查询单位信息变更列表
export function getQyxxBgList(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/qyxxBgjl/list",
    data: data
  })
}

//获取最新的变更记录信息
export function getNewBgxx() {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/qyxxBgjl/addDwbgjl"
  })
}
//获取最新的变更记录信息
export function addaddOrUpdSave(dwbgjlId, data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/qyxxBgjl/addaddOrUpdSave/" + dwbgjlId,
    data: data
  })
}
//获取最新的变更记录信息
export function saveBgjlPdYwlx(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/qyxxBgjl/saveBgjlPdYwlx",
    data: data
  })
}
//删除草稿
export function deleteFraftById(id) {
  return request({
    method: 'delete',
    url: "/yzdservice/enterprise/qyxxBgjl/removeDwbgjl/" + id
  })
}

//编辑草稿
export function editDraft(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/qyxxBgjl/detail/" + id
  })
}
//查看修改记录
export function lookDraft(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/qyxxBgjl/detailCompare/" + id
  })
}
//查看企业信息变更列表 /yzdservice/enterprise/qyxxBgjl/list
export function getQyxxBgjl(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/qyxxBgjl/list",
    data: data
  })
}
//获取已有资质证件
export function getBgjlZzjls(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/qyxxBgjl/getBgjlZzjls/" + id
  })
}
//获取某证件类型列表
export function getBgjlZjlistByZjlx(dwbgjlId, zjlx) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/qyxxBgjl/getBgjlZjlistByZjlx/" + dwbgjlId + "/" + zjlx
  })
}
//获取某资质证件详情
export function getBgjlZjlistDetail(sjxxId) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/qyxxBgjl/getBgjlZjlistDetail/" + sjxxId
  })
}
//新增/保存资质证件数据
export function addOrUpdSaveZzzj(dwbgjlId, data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/qyxxBgjl/addOrUpdSaveZzzj/" + dwbgjlId,
    data: data
  })
}
//删除资质证件数据
export function removeZzzjById(dwbgjlId, sjxxId) {
  return request({
    method: 'put',
    url: "/yzdservice/enterprise/qyxxBgjl/removeZzzjById/" + dwbgjlId + "/" + sjxxId
  })
}
//停用/启用资质证件数据
export function changeZzzjStatus(dwbgjlId, data) {
  return request({
    method: 'put',
    url: "/yzdservice/enterprise/qyxxBgjl/changeZzzjStatus/" + dwbgjlId,
    data: data
  })
}
